import React, { Component, Fragment } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import HeaderBanner from "../../components/header-banner";
import Loading from "../../components/Loading";

import { PAGES, RESOURCES } from "../../constants/constants";
import { gaPageview } from "../../utils/dev";

export default class ResourcesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      resources: null,
      medias: []
    };
    this.vetchatAPI = "https://www.vetchat.com.au/wp-json/wp/v2";

    this.loadResoruces = this.loadResoruces.bind(this);
    this.loadEbooks = this.loadEbooks.bind(this);
    this.loadInfographics = this.loadInfographics.bind(this);
  }
  componentDidMount() {
    const page = PAGES["resources"];
    document.title = page.title;

    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    gaPageview(this.props.location);

    //get resources
    this.loadResoruces();
  }

  decodeHtml(data) {
    var txt = document.createElement("textarea");
    txt.innerHTML = data;
    return txt.value;
  }

  loadResoruces = () => {
    let resources = [];
    this.setState({ isLoading: true }, async () => {
      try {
        await axios.get(`/resources/type/eBooks`).then(res => {
          resources["ebooks"] = res.data;
        });
        await axios.get(`/resources/type/Infographics`).then(res => {
          resources["infographics"] = res.data;
        });
      } catch (err) {
        console.log("Error fetchign resource from WP: ", err);
      }
      // console.log(medias);
      this.setState({ resources, isLoading: false });
    });
  };

  loadEbooks() {
    if (this.state.resources === undefined || this.state.resources === null) {
      return null;
    }

    const { ebooks } = this.state.resources;

    if (ebooks === undefined || ebooks.length === 0) {
      return null;
    }
    console.log(ebooks);

    return ebooks.map((book, index) => {
      return (
        <Fragment key={`ebook-${index}`}>
          <div className="col-sm-4 space-small-bottom">
            <Link to={`/resource/ebook/${book.id}`}>
              <div style={{ minHeight: 45, marginBottom: 8 }}>{book.title}</div>
              <img
                src={`${axios.defaults.baseURL}/uploads/${book.featured_image}`}
                alt={book.title}
                style={{ width: "100%" }}
              />
            </Link>
          </div>
          {(index + 1) % 3 === 0 && <div className="clear" />}
        </Fragment>
      );
    });
  }

  loadInfographics() {
    if (this.state.resources === undefined || this.state.resources === null) {
      return null;
    }
    const { infographics } = this.state.resources;

    if (infographics === undefined || infographics.length === 0) {
      return null;
    }

    return infographics.map((book, index) => {
      return (
        <Fragment key={`ebook-${index}`}>
          <div className="col-sm-4 space-small-bottom">
            <Link to={`resource/infographic/${book.id}`}>
              <div style={{ minHeight: 45, marginBottom: 8 }}>{book.title}</div>
              <img
                src={`${axios.defaults.baseURL}/uploads/${book.featured_image}`}
                alt={book.title}
                style={{ width: "100%" }}
              />
            </Link>
          </div>
          {(index + 1) % 3 === 0 && <div className="clear" />}
        </Fragment>
      );
    });
  }

  render() {
    const page = PAGES["resources"];
    const { isLoading } = this.state;

    /* let mapResources = "";
        
        if(resources !== undefined && resources.length > 0) {


            mapResources = resources.map( (resource,index) => {
                // let  media = "";
                const featuredImage = medias[index];
                return(
                    <Fragment key={`resources-${index}`}>
                    <div className="col-sm-4" >
                        <Link to={`/resource/${resource.slug}`}>
                            <h4>{this.decodeHtml(resource.title.rendered)}</h4>
                        </Link >
                        <div className="image">
                            <Link to={`/resource/${resource.slug}`}>
                                <img src={featuredImage} alt={resource.title.rendered} className="img-responsive"/>
                            </Link>
                        </div>
                    </div>
                    {( index + 1 ) % 3 === 0 && (
                        <div className="clear"></div>
                    )}
                    </Fragment>
                );
            })
        } */
    return (
      <Fragment>
        {HeaderBanner(page.bannerTitle, page.bannerImage)}
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="resources-title space-top text-center">
                <h3>{RESOURCES.title}</h3>
                <p className="space-small-bottom">{RESOURCES.description}</p>
              </div>
              <hr />
            </div>
            <div className="col-12 space-small-bottom space-small-top">
              {isLoading && <Loading title={`Loading Resources`} />}
              {!isLoading && (
                <div className="row">
                  <div className="col-sm-12 text-center space-small-bottom">
                    <h3>eBooks</h3>
                  </div>
                  {this.loadEbooks()}
                  <div className="col-sm-12 text-center space-small-bottom">
                    <hr />
                    <h3>Infographics</h3>
                  </div>
                  {this.loadInfographics()}
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
